import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { getAuthSession, saveAuthSession, toAuthSession } from '../utils/authStorage';

export function useProvideAuth() {
  const [error, setError] = useState('');
  const { state } = useLocation();
  const navigate = useNavigate();
  const from = state?.from?.pathname || '/home';

  const googleSignin = async (idToken) => {
    try {
      setError('');
      if (!idToken) throw new Error('Google credential is missing.');
      const { data } = await api.googleLogin(idToken);
      if (data.returnCode !== '0') throw new Error(data.message);
      handleSuccess(data);
    } catch (err) {
      console.log(err);
      setError(err.message);
    }
  };

  return {
    error,
    isAuth: getAuthSession(),
    setError,
    googleSignin,
  };

  function handleSuccess(data) {
    saveAuthSession(toAuthSession(data));
    navigate(from, { replace: true });
  }
}
